import { manualUpdateActionType } from "../actions/actionTypes";

let initialState = {};
const manualUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case manualUpdateActionType.GET_DROPDOWN_VALUE:
      var currState = { ...state, isLoading: true };
      return currState;
    case manualUpdateActionType.GET_DROPDOWN_VALUE_SUCCESSED:
      return action.payload;
    case manualUpdateActionType.GET_DROPDOWN_VALUE_FAILED:
      return action.payload;
    default:
      return state;
  }
};
export default manualUpdateReducer;
